import requests from "./httpService";

const CoupanServices = {

    getCoupan: async () =>{
        return requests.get(`/coupan`);
    },
    updateCoupanStatus : async (id,body) =>{
        return requests.patch(`/coupan/status/${id}`,body);
    },

    createCoupan : async (body) =>{
      
        return requests.post(`/coupan`,body);
    },

    deleteCoupan : async (id) =>{
        return requests.delete(`/coupan/${id}`);
    },
  
    updateCoupon : async (id,body) =>{
        return requests.patch(`coupan/coupan/${id}`,body);
    },


}
export default CoupanServices;